import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Form } from "react-bootstrap";
export var KFormOptionType;
(function (KFormOptionType) {
    KFormOptionType["BOOLEAN"] = "boolean";
    KFormOptionType["STRING"] = "string";
    KFormOptionType["NUMBER"] = "number";
    KFormOptionType["DATE"] = "date";
})(KFormOptionType || (KFormOptionType = {}));
export const KForm = ({ options, onSubmit, onSubmitting, children }) => {
    const [validated, setValidated] = useState(false);
    function castToOption(value, option) {
        if (!option) {
            return value || undefined;
        }
        else {
            switch (option) {
                case KFormOptionType.BOOLEAN:
                    return !!value;
                case KFormOptionType.NUMBER:
                    return value !== undefined ? +value : undefined;
                case KFormOptionType.STRING:
                    return value || undefined;
                case KFormOptionType.DATE:
                    return value ? new Date(value) : undefined;
            }
        }
    }
    async function handleSubmit(event) {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        const formData = new FormData(form);
        const formValues = {};
        for (const [name, value] of Array.from(formData.entries())) {
            formValues[name] = castToOption(value, options && options[name]);
        }
        if (options) {
            for (const [name, option] of Object.entries(options)) {
                if (!formValues[name]) {
                    formValues[name] = castToOption(undefined, option);
                }
            }
        }
        if (form.checkValidity()) {
            if (onSubmitting) {
                onSubmitting(true);
            }
            try {
                await onSubmit(formValues);
            }
            finally {
                if (onSubmitting) {
                    onSubmitting(false);
                }
                setValidated(true);
            }
        }
        else {
            setValidated(true);
        }
    }
    return (_jsx(Form, { noValidate: true, validated: validated, onSubmit: handleSubmit, children: children }));
};
